import React from 'react';
import styles from '../../styles/onlineCounselling.module.scss';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import CustomImage from '../CustomImage'; 
import Button from 'react-bootstrap/Button';
import { useRouter } from 'next/router';
import Breadcrumb  from 'react-bootstrap/Breadcrumb';
import useZipmeLink from '../../hooks/useZipmeLink';
import { isFrappeOrJotFormClass } from '../../utils/helpers';

interface Props {
    data: any;
    jotformId: number;
    externalLink:any;
    slug: string;
}

const HeaderSection: React.FC<Props> = ({ data, jotformId, externalLink , slug}) => {
    const { zipmeLink, generateLink } = useZipmeLink();
    const router = useRouter();
    return (
        <div className={styles.banner} >
            <Container>
                {(router.asPath.includes('/study-abroad-online-counselling') || router.asPath.includes('/branch/')  && !router.asPath.includes('/online-counselling/')) && <div className={styles.nav}>
                    <Row>
                        <Col>
                            <Nav>
                                <CustomImage src="/images/educationfair/kc_logo.svg" width={180} height={45} className={styles.navLogo} alt="kclogo" />
                            </Nav>
                        </Col>
                    </Row>
                </div>}
              
                { 
                (!router.asPath.includes('/study-abroad-online-counselling') && router.asPath.startsWith('/online-counselling/')) &&
                <Breadcrumb className={styles.mobileBreadCrum}>
                    <Breadcrumb.Item href="/" style={{ opacity: 0.5 }}>
                    Home
                    </Breadcrumb.Item>
                    {router.asPath === '/online-counselling' ? (
                    <Breadcrumb.Item href=''>
                        Online Counselling
                    </Breadcrumb.Item>
                    ) : (
                    <>
                        <Breadcrumb.Item href='/online-counselling' style={{ opacity: 0.5 }}>
                        Online Counselling
                        </Breadcrumb.Item>
                        <Breadcrumb.Item href=''>
                        {slug === 'usa' ? 'USA' : slug === 'uk' ? 'UK' :
                        slug.replace(/-/g, ' ').replace(/\b\w/g, (char, index) => char.toUpperCase())}
                      </Breadcrumb.Item>
                    </>
                    )}
                </Breadcrumb>
                }

                <div className={styles.maincontent}>
                    <Row>
                        <Col xl={6} lg={6} md={12} xs={12} className={styles.hdraside}>
                            <div className={styles.mainSectionBg}>
                                <div className={styles.sponserdSecdesk}>
                                    <h1 style={{ color: data?.titleColor || "#fff" }}>{data.mainTitle}</h1>
                                    <p style={{ color: data?.subTitleColor || "#fff" }}>{data.subTitle}</p>
                                </div>
                                <div className={styles.fairdetails}>
                                    <div className={styles.ulItem}>
                                        <ul>
                                            {
                                                data?.points?.length > 0 &&
                                                data?.points?.map((pointImg: any) => {
                                                    return (
                                                        <li style={{ color: data?.pointsColor || "#fff" }}>
                                                            <CustomImage src={pointImg?.imageUrl || "/images/starthd.png"} width={20} height={20} alt="EdTech1" />
                                                            <span>{pointImg.title}</span>
                                                        </li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    </div>
                                    <div className={styles.regBtn}>
                                        <Button onClick={() => {
                                        !jotformId && generateLink(externalLink)
                                       }}
                                        className={`${styles.btnReg}${jotformId
                                            ? ` ${isFrappeOrJotFormClass(jotformId)}`
                                            : ''
                                            }`}
                                    >
                                        { data.button?.[0]?.label || 'Register Now' }
                                    </Button>
                                        
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col xl={6} lg={6} md={12} xs={12} className={styles.hdrbside}>
                            <div className={styles.bannerStudDiv}>
                                <div className={styles.bg}>
                                    <CustomImage src={data?.mainImageUrl || "/images/headimg.png"} width={450} height={450} alt="bannergirl" priority isLazyLoad={false} />
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>
        </div>
    )
}

export default HeaderSection;